/**
 * `GET|PUT /v1/sites/:site_id/rescan-schedule` — Settings → Endpoint
 * "Re-scan schedule" (scheduled-jobs runbook, 2026-09-25).
 */
import type { SiteRescanCadence, SiteRescanSchedule } from '@sill/types/api';

import { ApiError, type HttpClient } from './http-client.js';

export type RescanScheduleResult =
  | { readonly kind: 'ok'; readonly schedule: SiteRescanSchedule }
  | { readonly kind: 'forbidden' }
  | { readonly kind: 'error'; readonly message: string };

function fail(err: unknown): RescanScheduleResult {
  if (err instanceof ApiError && err.kind === 'forbidden') return { kind: 'forbidden' };
  return { kind: 'error', message: err instanceof Error ? err.message : 'Network error.' };
}

export async function getSiteRescanSchedule(
  http: HttpClient,
  site_id: string,
): Promise<RescanScheduleResult> {
  try {
    const res = await http.request<SiteRescanSchedule>({
      method: 'GET',
      path: `/v1/sites/${encodeURIComponent(site_id)}/rescan-schedule`,
    });
    if (res === undefined) return { kind: 'error', message: 'Empty response body.' };
    return { kind: 'ok', schedule: res };
  } catch (err) {
    return fail(err);
  }
}

export async function putSiteRescanSchedule(
  http: HttpClient,
  site_id: string,
  rescan_cadence: SiteRescanCadence,
): Promise<RescanScheduleResult> {
  try {
    const res = await http.request<SiteRescanSchedule>({
      method: 'PUT',
      path: `/v1/sites/${encodeURIComponent(site_id)}/rescan-schedule`,
      body: { rescan_cadence },
    });
    if (res === undefined) return { kind: 'error', message: 'Empty response body.' };
    return { kind: 'ok', schedule: res };
  } catch (err) {
    return fail(err);
  }
}
